

const assetVersion = '9.1.6';
const interactionEvents = ['click', 'scroll', 'mousemove', 'mousewheel', 'touchstart'];
let interactionTriggered = false;

interactionEvents.forEach(function (eventName) {
	document.addEventListener(eventName, handleFirstInteraction, { once: true, passive: true });
});

function handleFirstInteraction() {
	if (interactionTriggered) {
		return;
	}
	interactionTriggered = true;

	const styles = [
		{
			id: 'fancy-css',
			href: 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@6.1/dist/fancybox/fancybox.css'
		},
		{
			id: 'swiper-style',
			href: 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css'
		},
		{
			id: 'data-tables-style',
			href: 'https://cdn.datatables.net/2.2.2/css/dataTables.dataTables.min.css'
		},
		{
			id: 'share-this-share-buttons-sticky-css',
			href: '/wp-content/plugins/sharethis-share-buttons/css/mu-style.css'
		}
	];

	const buildJsUrl = (window.wp_ajax_data?.template_url || '') + '/build/js';
	const srcJsUrl = (window.wp_ajax_data?.template_url || '') + '/src/js';

	const jQueryScript = {
		id: 'jquery',
		src: srcJsUrl + '/jquery.min.js',
		check: () => typeof window.jQuery !== 'undefined'
	};

	const dependentScripts = [
		{
			id: 'data-tables-script',
			src: 'https://cdn.datatables.net/2.2.2/js/dataTables.min.js',
			check: () => typeof window.jQuery?.fn?.DataTable === 'function'
		},
		{
			id: 'primary-script',
			src: buildJsUrl + '/script.min.js'
		},
		// Only animationScript and lenisScript use ScrollTrigger, so it loads here
		// instead of on every page load (its load-time refresh measured the whole page).
		{
			id: 'gsap-scroll-trigger-script',
			src: 'https://unpkg.com/gsap@3.13.0/dist/ScrollTrigger.min.js',
			check: () => typeof window.ScrollTrigger !== 'undefined'
		},
		{
			id: 'animation-script',
			src: buildJsUrl + '/animationScript.min.js',
			delay: 100
		},
		{
			id: 'swiper-script',
			src: 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js',
			check: () => typeof window.Swiper !== 'undefined',
			delay: 150
		},
		{
			id: 'slider-script',
			src: buildJsUrl + '/sliderScript.min.js',
			delay: 200
		}
	];

	// Slate embeds render into a div that editors place through the block
	// editor, and the embed script targets that div by id. Derive the config
	// from the form id so the two cannot drift, and skip the request entirely
	// on pages that do not contain the div.
	function slateForm(id, formId) {
		return {
			id,
			src: `https://apply.pioneeracademics.com/register/?id=${formId}&output=embed&div=form_${formId}`,
			when: () => document.getElementById('form_' + formId) !== null
		};
	}

	const otherScripts = [
		// {
		//   id: 'wistia-script-js',
		//   src: 'https://fast.wistia.net/assets/external/E-v1.js',
		//   check: () => typeof window.Wistia !== 'undefined'
		// },
		slateForm('slate-infosession-form-script-js', '1fc087bf-8369-4353-bedb-2bcff82be4d7'),
		slateForm('slate-pdf-email-list-form-script-js', '149a9c8e-8a32-4a49-9857-5b5dcf3c325b'),
		slateForm('slate-student-survey-js', '44ac150d-f783-4929-8101-a2a0724cf215'),
		{
			id: 'fancy-script',
			src: 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@6.1/dist/fancybox/fancybox.umd.js',
			check: () => typeof window.Fancybox !== 'undefined'
		},
		{
			id: 'lenis-scroll-script',
			src: buildJsUrl + '/lenisScript.min.js'
		},
		{
			id: 'share-this-share-buttons-mu-js',
			src: 'https://platform-api.sharethis.com/js/sharethis.js?ver=2.3.6#property=668cf181b8a87d001aa5f620&product=inline-buttons&source=sharethis-share-buttons-wordpress'
		}
	];

	function sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	function waitUntil(conditionFn, timeout = 1500, interval = 50) {
		return new Promise((resolve, reject) => {
			const startedAt = Date.now();

			const checkCondition = () => {
				if (conditionFn()) {
					resolve();
					return;
				}

				if (Date.now() - startedAt > timeout) {
					reject(new Error('Timeout waiting for condition'));
					return;
				}

				setTimeout(checkCondition, interval);
			};

			checkCondition();
		});
	}

	function ensureStyleLoaded({ id, href }) {
		if (document.getElementById(id)) {
			return;
		}

		const style = document.createElement('link');
		style.rel = 'stylesheet';
		style.id = id;
		style.href = href;
		style.type = 'text/css';
		style.media = 'all';
		document.head.appendChild(style);
	}

	// Cache-bust theme assets only. Third-party URLs already carry their own
	// version, and blindly appending '?ver=' corrupts any of them that rely on a
	// query string - the Slate embeds read their target div out of one, so the
	// stray param folded into the div name and the request came back 403.
	function buildScriptUrl(src) {
		if (src.indexOf('/wp-content/') === -1) {
			return src;
		}

		return src + (src.indexOf('?') === -1 ? '?' : '&') + 'ver=' + assetVersion;
	}

	function loadScript({ id, src }) {
		return new Promise((resolve, reject) => {
			if (document.getElementById(id)) {
				resolve();
				return;
			}

			const script = document.createElement('script');
			script.id = id;
			script.src = buildScriptUrl(src);
			script.type = 'text/javascript';
			script.onload = () => resolve();
			script.onerror = () => reject(new Error(`Failed to load: ${src}`));
			document.body.appendChild(script);
		});
	}

	async function loadScriptConfig(scriptConfig) {
		const { id, src, check, when, delay = 0 } = scriptConfig;

		if (typeof when === 'function' && !when()) {
			return;
		}

		if (delay > 0) {
			await sleep(delay);
		}

		try {
			await loadScript({ id, src });
			if (typeof check === 'function') {
				await waitUntil(check);
			}
		} catch (err) {
			console.error(`[script-loader] ${id}:`, err.message);
		}
	}

	async function loadScriptGroupSequentially(scripts) {
		for (const scriptConfig of scripts) {
			await loadScriptConfig(scriptConfig);
		}
	}

	// Nothing in this group depends on anything else in it, so a slow script
	// should not hold up the rest the way a sequential walk does.
	function loadScriptGroupInParallel(scripts) {
		return Promise.all(scripts.map(config => loadScriptConfig(config)));
	}

	async function initInteractionScripts() {
		styles.forEach(ensureStyleLoaded);

		try {
			await loadScript({ id: jQueryScript.id, src: jQueryScript.src });
			await waitUntil(jQueryScript.check);
		} catch (err) {
			console.error('[script-loader] jquery:', err.message);
			return;
		}

		await loadScriptGroupSequentially(dependentScripts);
		await loadScriptGroupInParallel(otherScripts);
	}

	initInteractionScripts();

	if (document.getElementById('pa-cookie-consent-banner')) {
		// Cookie banner display
		function setCookie(name, value, days) {
			let expires = "";
			if (days) {
				let date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				expires = "; expires=" + date.toUTCString();
			}
			document.cookie = name + "=" + (value || "") + expires + "; path=/";
		}

		function getCookie(name) {
			let nameEQ = name + "=";
			let ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		}

		if (!getCookie('cookieAccepted')) {
			document.getElementById('pa-cookie-consent-banner').style.display = 'block';
		}

		document.getElementById('pa-consent-accept').addEventListener('click', function (e) {
			e.preventDefault();
			setCookie('cookieAccepted', 'true', 30); // Expires in 30 days
			document.getElementById('pa-cookie-consent-banner').style.display = 'none';
		});
	}

	// Select all iframes with class "wistia-src"
	const wistiaIframes = document.querySelectorAll("iframe.wistia-src");

	if (wistiaIframes.length) {
		wistiaIframes.forEach(iframe => {
			// Only set src if it hasn't been set yet
			if (!iframe.hasAttribute("src")) {
				const url = iframe.getAttribute("data-wistia-src");
				if (url) {
					iframe.setAttribute("src", url);
					iframe.classList.remove('wistia-skeleton');
				}
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', function () {
	window.browserScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

	// Hamburger menu click
	if (document.querySelector(".hamburger")) {
		const hamburger = document.querySelector(".hamburger");
		const header = document.querySelector("header");
		const body = document.body;
		const html = document.documentElement;
		const navLinks = document.querySelectorAll(".nav-link");
		const navCta = document.querySelector(".nav-cta");

		hamburger.addEventListener("click", () => {
			const expanded = hamburger.getAttribute("aria-expanded") === "true";
			hamburger.setAttribute("aria-expanded", String(!expanded));

			header.classList.toggle("active");
			body.classList.toggle("overflow");
			html.classList.toggle("overflow");

			const baseDelay = 0.22;
			const increment = 0.02;

			navLinks.forEach((el, i) => {
				el.style.transitionDelay = `${baseDelay + i * increment}s`;
			});

			if (navCta) {
				navCta.style.transitionDelay = `${baseDelay + navLinks.length * increment + 0.04}s`;
			}
		});
	}

	// Global search popup feature
	if (document.querySelectorAll('.header-search-cta').length) {
		document.querySelectorAll('.header-search-cta').forEach(cta => {
			cta.addEventListener('click', e => {
				e.preventDefault();

				const isDesktop = window.innerWidth >= 1024;
				const searchForm = document.querySelector(isDesktop ? '.search-form-desktop' : '.search-form-mobile');
				const searchInput = searchForm.querySelector('input');
				const searchButton = searchForm.querySelector('button');
				const searchContainer = searchInput.closest('.search-input-container');

				// Toggle visibility using class or style (equivalent to fadeToggle in jQuery)
				if (searchForm.style.display === 'none' || getComputedStyle(searchForm).display === 'none') {
					searchForm.style.display = 'block';
					searchForm.style.opacity = 0;
					searchForm.style.transition = 'opacity 0.3s ease';
					requestAnimationFrame(() => {
						searchForm.style.opacity = 1;
					});
				} else {
					searchForm.style.transition = 'opacity 0.3s ease';
					searchForm.style.opacity = 0;
					setTimeout(() => {
						searchForm.style.display = 'none';
					}, 300);
				}

				searchInput.focus();

				// Attach keyup handler once per form
				if (!searchInput._keyupHandlerAttached) {
					searchInput.addEventListener('keyup', () => {
						if (searchInput.value.trim() !== "") {
							searchContainer.classList.remove('search-error');
						} else {
							searchContainer.classList.add('search-error');
						}
					});
					searchInput._keyupHandlerAttached = true; // Custom flag to prevent re-binding
				}
			});
		});
	}

	// Desktop (lg+) primary navigation: sub-menus open on hover via CSS (see global.css).
	// Mobile accordion behaviour lives in script.js and is untouched below lg.
	const primaryNavigation = document.getElementById('menu-primary-navigation');
	if (primaryNavigation) {
		const desktopQuery = window.matchMedia('(min-width: 1024px)');

		// Placeholder "#" top-level links should not jump to the top of the page on desktop
		primaryNavigation.querySelectorAll(':scope > .menu-item-has-children > a[href="#"]').forEach(link => {
			link.addEventListener('click', e => {
				if (desktopQuery.matches) e.preventDefault();
			});
		});

		// Clear leftover mobile accordion state (classes and inline styles from jQuery slideToggle)
		// so it cannot block the hover sub-menus after resizing up to lg
		const resetMobileState = () => {
			if (!desktopQuery.matches) return;
			primaryNavigation.querySelectorAll('.menu-item-has-children.active').forEach(item => item.classList.remove('active'));
			primaryNavigation.querySelectorAll('.sub-menu, .combined-menu-container').forEach(el => el.style.removeProperty('display'));
			document.querySelectorAll('.primary-navigation.primary-menu-active').forEach(nav => nav.classList.remove('primary-menu-active'));
		};

		if (desktopQuery.addEventListener) {
			desktopQuery.addEventListener('change', resetMobileState);
		} else {
			desktopQuery.addListener(resetMobileState);
		}
	}

	// Remove skeleton
	const skeletons = document.querySelectorAll('.skeleton');
	if (skeletons.length) {
		skeletons.forEach(el => el.classList.remove('skeleton'));
	}

	// Text reveal animations
	// Trigger the animation on multiple selectors
	let generatedTextClass = [];

	setTimeout(() => {
		[
			'.multi-line-animate > p',
			'.section-heading:not(.no-animation)',
			'.slide-up-heading:not(.no-animation)',
			'.section-heading-white:not(.no-animation)'
		].forEach(selector => textRevealAnimation(selector));
	}, 0);

	function textRevealAnimation(selector) {
		const elements = document.querySelectorAll(selector);
		if (!elements.length) return;

		const textAnimateClass = selector.replace(/[.\s)(:>]/g, '') + 1;

		generatedTextClass.push(textAnimateClass); // Push into array

		// Splitting every heading on the page up front forced a layout per heading
		// during load, so split each one only as it nears the viewport.
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				splitIntoLine(entry.target, selector, Array.prototype.indexOf.call(elements, entry.target));
			});
		}, { rootMargin: '200px 0px' });

		elements.forEach(el => observer.observe(el));

		let resizeTimeout;
		let lastWidth = window.innerWidth;

		window.addEventListener('resize', () => {
			const currentWidth = window.innerWidth;
			if (currentWidth !== lastWidth) {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(() => {
					elements.forEach((el, idx) => {
						if (el.dataset.textRevealReady) {
							splitIntoLine(el, selector, idx);
						}
					});
				}, 300);
				lastWidth = currentWidth;
			}
		});
	}

	// Plays a heading's reveal when its top crosses the bottom of the viewport,
	// and again each time it re-enters from below. This replaces a ScrollTrigger
	// per heading (start/end "top bottom", toggleActions "restart none none none"),
	// which re-measured every heading on each refresh.
	const revealTweens = new WeakMap();
	const revealPlayObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			const tween = revealTweens.get(entry.target);
			if (!tween) return;

			const firstCheck = !entry.target.dataset.textRevealSeen;
			entry.target.dataset.textRevealSeen = '1';

			if (entry.isIntersecting && (firstCheck || entry.boundingClientRect.top > 0)) {
				tween.restart();
			} else if (firstCheck && entry.boundingClientRect.top < 0) {
				// Already scrolled past it: show it fully.
				tween.progress(1).pause();
			}
		});
	});

	function splitIntoLine(el, selector, idx) {
		el.dataset.textRevealReady = '1';
		el.style.opacity = 1;

		// Split into lines using SplitType
		const lines = new SplitType(el, {
			types: 'lines',
			lineClass: 'line'
		}).lines;

		lines.forEach(line => {
			new SplitType(line, {
				types: 'lines',
				lineClass: 'line'
			});
		});

		// Generate a unique class for each element based on selector and index
		const textRevealClass = selector.replace(/[.\s)(:>]/g, '') + (idx + 1);
		const parent = el.parentElement;

		const nextIsP = el.nextElementSibling?.tagName.toLowerCase() === 'p';
		const prevIsP = el.previousElementSibling?.tagName.toLowerCase() === 'p';

		if (nextIsP || prevIsP) {
			parent.classList.add(textRevealClass);
		} else {
			el.classList.add(textRevealClass);
		}

		const target = document.querySelector('.' + textRevealClass);
		const innerLines = target?.querySelectorAll('.line .line') || [];

		if (innerLines.length) {
			const tween = gsap.fromTo(
				innerLines,
				{
					opacity: 0,
					y: 100
				},
				{
					opacity: 1,
					y: 0,
					duration: 1.4,
					ease: "power4",
					stagger: 0.1,
					paused: true
				}
			);

			const previousTween = revealTweens.get(target);
			if (previousTween) previousTween.kill();
			revealTweens.set(target, tween);

			if (target.dataset.textRevealSeen) {
				// Re-split after a resize: replay if it is already in or above the viewport.
				if (target.getBoundingClientRect().top < window.innerHeight) tween.restart();
			} else {
				revealPlayObserver.observe(target);
			}
		}
	}

	// Function to check if both libraries are loaded
	function waitForChartScripts(callback) {
		const interval = setInterval(() => {
			if (window.Chart && window.ChartDataLabels) {
				clearInterval(interval);
				callback();
			}
		}, 50);
	}

	waitForChartScripts(() => {
		// Doughnut chart
		if (document.querySelector('.content-with-doughnut-chart')) {
			const chartWrapper = document.querySelector('.chart-wrapper');

			// Parse the data attributes
			const doughnutLabels = JSON.parse(chartWrapper.getAttribute('data-chart-label'));
			const doughnutValues = JSON.parse(chartWrapper.getAttribute('data-chart-value'));
			const doughnutColors = JSON.parse(chartWrapper.getAttribute('data-chart-color'));

			const doughnutTotal = parseInt(doughnutValues[0], 10);   // 303
			const doughnutMatched = parseInt(doughnutValues[1], 10); // 289
			const doughnutUnmatched = doughnutTotal - doughnutMatched;

			const doughnutChartLP = document.getElementById('doughnutChart').getContext('2d');


			const chart = new Chart(doughnutChartLP, {
				type: 'doughnut',
				data: {
					labels: doughnutLabels,
					datasets: [{
						data: [doughnutMatched, doughnutUnmatched],
						backgroundColor: doughnutColors,
						borderWidth: 0,
						cutout: '45%' // Doughnut hole
					}]
				},
				options: {
					responsive: true,
					maintainAspectRatio: true,
					plugins: {
						legend: {
							display: false
						},
						tooltip: {
							enabled: false
						}
					},
					elements: {
						arc: {
							borderWidth: 0
						}
					},
					animation: {
						animateRotate: true,
						animateScale: false
					}
				}
			});
		}

		// Vertical Bar Chart
		if (document.querySelector('.content-with-vertical-bar-chart')) {
			document.querySelectorAll('.content-with-vertical-bar-chart .chart-wrapper').forEach(container => {
				const responses = JSON.parse(container.dataset.chartData);
				const canvasId = container.dataset.chartId;
				const canvasTopTitle = container.dataset.topTitle;
				const canvasYAxisStep = container.dataset.yAxisStep;
				const canvas = document.getElementById(canvasId);

				const verticalBarChart = canvas.getContext('2d');

				const labels = responses.map(item => item.label);
				const data = responses.map(item => item.value);
				const backgroundColors = responses.map(item => item.color);
				let graphTopTitle;

				if (canvasTopTitle) {
					graphTopTitle = {
						display: true,
						text: canvasTopTitle,
						font: {
							size: 14,
							family: 'Mulish',
							weight: '400'
						},
						color: '#111',
						padding: {
							top: 10,
							bottom: 20
						}
					}
				} else {
					graphTopTitle = { display: false }
				}

				// Create the chart
				new Chart(verticalBarChart, {
					type: 'bar',
					data: {
						labels: labels,
						datasets: [{
							data: data,
							backgroundColor: backgroundColors,
							barThickness: 24,
							datalabels: {
								anchor: 'end',
								align: 'start',
								offset: -20,
								color: '#333',
								font: {
									size: 12,
									family: 'Mulish'
								}
							}
						}]
					},
					options: {
						responsive: true,
						maintainAspectRatio: false,
						scales: {
							x: {
								ticks: {
									font: { size: 12, family: 'Mulish' },
									color: '#666'
								},
								grid: { display: false }
							},
							y: {
								beginAtZero: true,
								max: 200,
								ticks: {
									stepSize: canvasYAxisStep,
									font: { size: 12, family: 'Mulish' },
									color: '#666'
								},
								grid: { color: '#e0e0e0' }
							}
						},
						plugins: {
							legend: { display: false },     // ✅ No legend
							tooltip: { enabled: false },
							datalabels: { display: true },
							title: graphTopTitle
						}
					},
					plugins: [ChartDataLabels]
				});
			});
		}

		// Horizontal and doughnut chart
		if (document.querySelector('.chart-with-content')) {
			document.querySelectorAll('.chart-flex-container').forEach(container => {
				const chartType = container.dataset.chartType;
				if (chartType == 'bar') {
					const responses = JSON.parse(container.dataset.chartData);
					const canvasId = container.dataset.chartId;
					const canvasXAxisStep = container.dataset.xAxisStep;
					const canvas = document.getElementById(canvasId);

					// Calculate dynamic height
					const barCount = responses.length + responses.length - 1; // includes spacer bars
					const barHeight = 24 + ((responses.length <= 6) ? 10 : 5); // actual bar + spacing bar
					const canvasHeight = barCount * barHeight;
					canvas.height = canvasHeight;

					const horizontalBar = canvas.getContext('2d');
					const datasets = [];

					responses.forEach((item, index) => {
						datasets.push({
							label: item.label,
							data: [item.value],
							backgroundColor: item.color,
							barThickness: 24,
							datalabels: {
								anchor: 'end',
								align: 'start',
								offset: -32,
								color: '#333',
								font: {
									size: 12,
									family: 'Mulish'
								}
							}
						});

						// Spacer bar
						if (index < responses.length - 1) {
							datasets.push({
								label: '',
								data: [0],
								backgroundColor: 'rgba(0, 0, 0, 0)',
								datalabels: { display: false },
								barThickness: 10
							});
						}
					});

					// Create the chart
					new Chart(horizontalBar, {
						type: 'bar',
						data: {
							labels: ['Students'],
							datasets: datasets
						},
						options: {
							indexAxis: 'y',
							responsive: true,
							maintainAspectRatio: false,
							scales: {
								x: {
									beginAtZero: true,
									max: 200,
									grid: { color: '#e0e0e0' },
									ticks: {
										stepSize: canvasXAxisStep,
										font: { size: 12, family: 'Mulish' },
										color: '#666'
									}
								},
								y: {
									ticks: { display: false },
									grid: { display: false }
								}
							},
							plugins: {
								legend: { display: false },
								tooltip: { enabled: false },
								datalabels: { display: true }
							}
						},
						plugins: [ChartDataLabels]
					});

					// Render the custom legend
					const legendContainer = container.querySelector('#customLegend');
					const legendItems = responses.map(item => `
              <li>
                <span class="legend-box" style="background-color: ${item.color};"></span><span class="legend-label">${item.label}</span>
              </li>
            `).join('');
					legendContainer.innerHTML = `<ul style="list-style: none; padding: 0; margin: 0;">${legendItems}</ul>`;
				} else {
					const responses = JSON.parse(container.dataset.chartData);
					const canvasId = container.dataset.chartId;
					const canvas = document.getElementById(canvasId);
					const ctx = canvas.getContext('2d');

					const data = {
						datasets: [{
							data: responses.map(item => item.value),
							backgroundColor: responses.map(item => item.color),
							borderWidth: 0,
							cutout: '45%'
						}]
					};

					const config = {
						type: 'doughnut',
						data: data,
						options: {
							responsive: true,
							maintainAspectRatio: false,
							plugins: {
								legend: { display: false },
								tooltip: { enabled: false }
							},
							animation: {
								duration: 1000
							},
							elements: {
								arc: {
									borderWidth: 0
								}
							}
						},
						plugins: [{
							afterDraw: function (chart) {
								try {
									const ctx = chart.ctx;
									const data = chart.data.datasets[0].data;

									chart.data.datasets[0].data.forEach((value, index) => {
										const meta = chart.getDatasetMeta(0);
										const arc = meta.data[index];

										if (arc && typeof arc.startAngle !== 'undefined' && typeof arc.endAngle !== 'undefined') {
											const centerAngle = arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
											const radius = (arc.innerRadius + arc.outerRadius) / 2;
											const x = arc.x + Math.cos(centerAngle) * radius;
											const y = arc.y + Math.sin(centerAngle) * radius;

											ctx.save();
											ctx.fillStyle = '#333';
											ctx.font = '14px Mulish';
											ctx.textAlign = 'center';
											ctx.textBaseline = 'middle';
											ctx.fillText(value.toString(), x, y);
											ctx.restore();
										}
									});
								} catch (error) {
									console.error('Error in afterDraw plugin:', error);
								}
							}
						}]
					};

					new Chart(ctx, config);

					// Render the custom legend
					const legendContainer = container.querySelector('#customLegend');
					const legendItems = responses.map(item => `
              <li>
                <span class="legend-box" style="background-color: ${item.color};"></span>
                <span class="legend-label">${item.label}</span>
              </li>
            `).join('');
					legendContainer.innerHTML = `<ul style="list-style: none; padding: 0; margin: 0;">${legendItems}</ul>`;
				}
			});
		}
	});

	document.addEventListener('keydown', function (e) {
		// Enter or Space, matching native button behavior
		if (e.key !== 'Enter' && e.key !== ' ') return;
	  
		const videoElement = e.target.closest('.wistia-video-embeded');
		if (!videoElement) return;
	  
		e.preventDefault(); // stop Space from scrolling the page
		videoElement.click(); // reuse the existing click handler
	});


	// Video popup modal — delegated, works for dynamic elements too
	document.addEventListener('click', function (e) {
		const videoElement = e.target.closest('.wistia-video-embeded');
		if (!videoElement) return;
	
		e.preventDefault();
	
		const videoId = videoElement.getAttribute('data-video-id');
		const haveModal = videoElement.querySelector('.video-modal-container');
		let clonedModal = null;
	
		const currentUrl = window.location.href.split('?')[0];
		const urlParams = new URLSearchParams(window.location.search);
		urlParams.set('video_id', videoId);
		const newUrl = currentUrl + (urlParams.toString() ? '?' + urlParams.toString() : '');
	
		if (haveModal && videoId === haveModal.id) {
		clonedModal = haveModal.cloneNode(true);
		} else if (videoElement.classList.contains('btn')) {
		const container = videoElement.closest('.btn-container');
		clonedModal = container?.querySelector('.video-modal-container.cta-video')?.cloneNode(true) || null;
		} else {
		const container = videoElement.closest('.have-embed-video');
		clonedModal = container?.querySelector('.video-modal-container:not(.cta-video)')?.cloneNode(true) || null;
		}
	
		if (!clonedModal) {
		console.warn('No modal found for', videoElement); // debug helper
		return;
		}
	
		document.body.appendChild(clonedModal);
	
		// --- Autoplay with sound ---
		const iframe = clonedModal.querySelector('iframe');
		const iframeSrc = iframe && (iframe.dataset.src || iframe.src);
		if (iframeSrc) {
		// Iframe embed: add autoplay params (the template only carries the URL in data-src)
		const src = new URL(iframeSrc);
		src.searchParams.set('autoPlay', 'true');
		src.searchParams.set('silentAutoPlay', 'false'); // false = play WITH sound
		iframe.src = src.toString();
		} else {
		// JS API embed (.wistia_embed div): play via Wistia's queue
		window._wq = window._wq || [];
		window._wq.push({
			id: videoId,
			onReady: function (video) {
			video.volume(1);
			video.play();
			}
		});
		}
		// --- End autoplay ---
	
		fadeIn(clonedModal, 500);
		document.body.classList.add('wistia-modal-active');
	
		const paddingValue = window.browserScrollbarWidth + 'px';
		document.querySelectorAll('body, header, .child-page-menu').forEach(function (el) {
		el.style.paddingRight = paddingValue;
		});
	
		window.history.pushState({ path: newUrl }, '', newUrl);
	});
	
	function fadeIn(element, duration) {
		element.style.removeProperty('display'); // clear any inline display:none from the clone
		element.style.opacity = '0';
		// If it's still hidden by CSS, force it visible
		if (getComputedStyle(element).display === 'none') {
		element.style.display = 'block';
		}
		element.style.transition = 'opacity ' + duration + 'ms';
		void element.offsetHeight; // force reflow so the transition runs
		element.style.opacity = '1';
	}

	// video landing functionality
	const urlParams = new URLSearchParams(window.location.search);

	if (urlParams.has('video_id')) {
		const videoId = urlParams.get('video_id');

		// Find the video CTA
		let videoLinkCta =
			document.querySelector('.wistia-video-embeded[data-video-id="' + videoId + '"]') ||
			document.querySelector('.thinking-slider-wrapper .modal-link a[data-video-id="' + videoId + '"]');

		if (videoLinkCta) {
			// Get offset heights
			const header = document.querySelector('header');
			const childMenu = document.querySelector('.child-page-menu');
			const adminBar = document.getElementById('wpadminbar');

			const headerHeight = header ? header.offsetHeight : 0;
			const childMenuHeight = childMenu ? childMenu.offsetHeight : 0;
			const wpAdminBarHeight = adminBar ? adminBar.offsetHeight : 0;

			// Calculate top position of section
			const section = videoLinkCta.closest('section');
			const sectionTop = section ? section.getBoundingClientRect().top + window.pageYOffset : 0;

			// Smooth scroll
			window.scrollTo({
				top: sectionTop - headerHeight - childMenuHeight - wpAdminBarHeight,
				behavior: 'smooth'
			});

			// Trigger the click after scrolling
			setTimeout(function () {
				videoLinkCta.click();
			}, 1000);
		}
	}

	// Masonry style
	const newsItems = document.querySelectorAll(".news-container .news-item");

	if (newsItems.length) {
		function positionItemsByColumn() {
			newsItems.forEach((item) => {
				setTimeout(() => {
					const height = item.offsetHeight + parseFloat(getComputedStyle(item).marginTop) + parseFloat(getComputedStyle(item).marginBottom);
					const computed = Math.ceil(height);
					item.style.setProperty("--height", computed);
				}, 100);
			});
		}

		positionItemsByColumn();

		// window.addEventListener('load', positionItemsByColumn);
		window.addEventListener('resize', positionItemsByColumn);
	}

	// PDF siderbartoggle button
	if (document.querySelector('.pdfp_iframe')) {
		function tryInitIframe() {
			const iframe = document.querySelector('.pdfp_iframe');
			if (!iframe) return;

			const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

			// Try hiding the download button repeatedly until found or timeout
			const tryHideSidebarToggle = setInterval(() => {
				const sidebarToggleButton = iframeDoc.getElementById('sidebarToggleButton') || iframeDoc.getElementById('sidebarToggleButton');
				if (sidebarToggleButton) {
					sidebarToggleButton.style.display = 'flex';
					clearInterval(tryHideSidebarToggle);
				}
			}, 300);

			// Stop trying after 5 seconds
			setTimeout(() => clearInterval(tryHideSidebarToggle), 5000);
		}

		// Wait for iframe to appear in DOM
		const checkIframeInterval = setInterval(() => {
			const iframe = document.querySelector('.pdfp_iframe');
			if (iframe && iframe.contentWindow && iframe.contentWindow.document.readyState === 'complete') {
				clearInterval(checkIframeInterval);
				tryInitIframe();
			}
		}, 300);

		// Optional: stop watching after 10 seconds
		setTimeout(() => clearInterval(checkIframeInterval), 10000);
	}

	if (document.querySelector('#cc--main #c-txt')) {
		function updateBanner() {
			const banner = document.querySelector('#cc--main #c-txt');
			if (!banner) return false;

			const isGDPRregion = window.isGDPRregion;

			// Non-GDPR region -> replace default text
			if (isGDPRregion === false) {
				const bannerModalDescription = document.querySelector('#s-bl .desc .p');
				const cookieBannerContent = window.nonGDPRcontent;
				const cookiepanelIntroduction = window.nonGDPRpanelIntroduction;
				const preferenceAccordionDetails = window.nonGDPRpreferenceAccordionDetails;

				if (cookieBannerContent) {
					banner.innerHTML = cookieBannerContent;
				}

				if (cookiepanelIntroduction && bannerModalDescription) {
					bannerModalDescription.innerHTML = cookiepanelIntroduction;
				}

				if (preferenceAccordionDetails.length) {
					preferenceAccordionDetails.forEach((detail, idx) => {
						const title = detail.title;
						const description = detail.description;
						const modalButton = document.querySelector(`button[aria-controls="c-ac-${idx + 1}"]`);
						const modalContainer = document.querySelector(`#s-bl #c-ac-${idx + 1} > .p`);

						if (modalButton && title) {
							modalButton.innerHTML = title;
						}

						if (modalContainer && description) {
							modalContainer.innerHTML = description;
						}
					});
				}
			}

			return true;
		}

		// Banner loads asynchronously -> wait
		let tries = 0;
		const interval = setInterval(() => {
			if (updateBanner() || ++tries > 40) {
				clearInterval(interval);
			}
		}, 150);
	}

	// Debounce helper
	function debounce(fn, delay = 150) {
		let timer;

		return function (...args) {
			clearTimeout(timer);

			timer = setTimeout(() => {
				fn.apply(this, args);
			}, delay);
		};
	}

	if (document.querySelectorAll('.flagship-institutes').length) {

		const container = document.querySelector('.flagship-institutes');
		let contentMaxHeight = 0;
		let lastWidth = window.innerWidth;

		function getMaxFullHeight(el) {
			const clone = el.cloneNode(true);

			// Hide clone
			clone.style.position = 'absolute';
			clone.style.visibility = 'hidden';
			clone.style.pointerEvents = 'none';
			clone.style.top = '-9999px';
			clone.style.left = '-9999px';
			clone.style.width = el.offsetWidth + 'px';

			document.body.appendChild(clone);

			const elements = clone.querySelectorAll(
				'.show-more-container .content-area'
			);

			const itemHeights = {};
			let maxHeight = 0;

			// Apply every style first, then measure, so the browser lays out once
			// instead of once per item.
			elements.forEach(item => {
				item.style.display = 'block';
				item.style.height = 'auto';
				item.style.maxHeight = 'none';
				item.style.webkitLineClamp = 'unset';
				item.style.overflow = 'visible';
			});

			elements.forEach((item, index) => {
				const height = item.scrollHeight;

				// Store individual height
				itemHeights[index] = height;

				// Track max height
				maxHeight = Math.max(maxHeight, height);
			});

			document.body.removeChild(clone);

			return {
				item: itemHeights,
				maxHeight,
			};
		}

		// Your resize handler
		function handleMaxHeightResize() {
			contentMaxHeight = getMaxFullHeight(container);

			const elements = document.querySelectorAll('.flagship-institutes-item .show-more-container .content-area');

			// First frame: reset styles (WRITE)
			requestAnimationFrame(() => {
				elements.forEach(el => {
					el.style.height = '';
					el.style.maxHeight = '';
				});

				// Second frame: read layout + apply (READ → WRITE)
				requestAnimationFrame(() => {
					elements.forEach((el, idx) => {

						if (window.innerWidth < 769) {
							el.dataset.maxHeight = contentMaxHeight.item[idx];
						} else {
							el.dataset.maxHeight = contentMaxHeight.maxHeight;
						}

						const height = el.offsetHeight; // layout read

						el.dataset.minHeight = height;
						el.style.maxHeight = `${height}px`;
					});
				});
			});
		}

		// Wrapper that checks width only
		function onResizeWidthOnly() {
			const currentWidth = window.innerWidth;

			if (currentWidth !== lastWidth) {
				lastWidth = currentWidth;
				handleMaxHeightResize();
			}
		}

		// Debounced
		const debouncedResize = debounce(onResizeWidthOnly, 250);

		// Initial run (after load is best)
		handleMaxHeightResize();

		// Listen to resize
		window.addEventListener('resize', debouncedResize);

		let lastDesktopWidth = window.innerWidth;
		const GROUP_SIZE = 2;
		const DESKTOP_WIDTH = 1024;

		const SELECTORS = [
			'.flagship-institutes-item .header',
			'.flagship-institutes-item .notification',
			'.flagship-institutes-item .info-cta',
			'.flagship-institutes-item .meta-details'
		];

		// Desktop check
		function isDesktop() {
			return window.innerWidth >= DESKTOP_WIDTH;
		}

		function resetHeights() {
			SELECTORS.forEach(selector => {
				container.querySelectorAll(selector).forEach(el => {
					el.removeAttribute('style');
				});
			});
		}

		// Measure every group before setting any height (resetHeights has already
		// cleared them), so the browser lays out once instead of once per group.
		function equalize(selectors) {
			const groups = [];

			selectors.forEach(selector => {
				const elements = Array.from(container.querySelectorAll(selector));

				for (let i = 0; i < elements.length; i += GROUP_SIZE) {
					const group = elements.slice(i, i + GROUP_SIZE);

					const maxHeight = group.reduce(
						(max, el) => Math.max(max, el.offsetHeight),
						0
					);

					groups.push({ group, maxHeight });
				}
			});

			groups.forEach(({ group, maxHeight }) => {
				group.forEach(el => {
					el.dataset.maxHeight = maxHeight;
					el.style.height = `${maxHeight}px`;
					el.style.maxHeight = `${maxHeight}px`;
				});
			});
		}

		function applyLayout() {
			// Always reset first
			resetHeights();

			// Only equalize on desktop
			if (!isDesktop()) return;

			equalize(SELECTORS);
		}

		// Initial run
		applyLayout();

		// Wrapper that checks width only
		function onHandleResizeWidthOnly() {
			const currentWidth = window.innerWidth;

			if (currentWidth !== lastDesktopWidth) {
				lastDesktopWidth = currentWidth;
				applyLayout();
			}
		}

		// Debounced
		const debouncedHandleResize = debounce(onHandleResizeWidthOnly, 250);

		// Listen to resize
		window.addEventListener('resize', debouncedHandleResize);

	}

	// Custom icon play animation if is in viewport
	const icons = document.querySelectorAll('.custom-icon');
	const notification = document.querySelectorAll('.flagship-institutes-item .notification');

	function playCustomAnimation(el) {
		if (el.length) {
			const observer = new IntersectionObserver(
				(entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							entry.target.classList.add('play-animation');
							observer.unobserve(entry.target); // play once
						}
					});
				},
				{
					threshold: 0.4, // 40% visible
				}
			);

			el.forEach(icon => observer.observe(icon));
		}
	}

	playCustomAnimation(icons);
	playCustomAnimation(notification);

	// Universities logo grid
	const gridUniversities = document.querySelector('.universities-container');

	if (gridUniversities) {
		let resizeUniversityTimer;

		function splitUniversities() {
			const universityItem = document.querySelectorAll('.university-item');
			if (universityItem.length < 17) return;

			const visibleGridUniversity = document.querySelector('.universities-container-visible');
			const hiddenGridUniversity = document.querySelector('.universities-container-hidden ul');

			visibleGridUniversity.innerHTML = '';
			hiddenGridUniversity.innerHTML = '';

			let limit = window.innerWidth < 1280 ? 18 : 16;

			universityItem.forEach((item, index) => {
				// Remove hidden class after moving
				item.classList.remove('hidden');

				if (index < limit) {
					visibleGridUniversity.appendChild(item);
				} else {
					hiddenGridUniversity.appendChild(item);
				}
			});

			gridUniversities.classList.add('hidden');
		}

		splitUniversities();
		window.addEventListener('resize', () => {
			clearTimeout(resizeUniversityTimer);
			resizeUniversityTimer = setTimeout(splitUniversities, 150);
		});
	}

	// Bring the slider to its actual position when the scroll hits the actual position
	const videoSlider = document.querySelectorAll('.reset-slider-on-scroll');

	if (videoSlider.length > 0) {
		videoSlider.forEach((element) => {

			// Remove Tailwind class if present
			element.classList.remove('!translate-x-percent-12');

			// Set initial position
			gsap.set(element, {
				x: '12%',
				opacity: 0,
			});

			// Animate once its top is 60px above the bottom of the viewport (or
			// straight away if it is already past that point). An IntersectionObserver
			// keeps ScrollTrigger out of the page load.
			const slideIn = gsap.to(element, {
				x: 0,
				opacity: 1,
				duration: 0.8,
				ease: 'power2.out',
				paused: true
			});

			const observer = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
						slideIn.play();
						observer.disconnect();
					}
				});
			}, { rootMargin: '0px 0px -60px 0px' });

			observer.observe(element);
		});
	}

	const containerSecondaryMenu = document.querySelector('.child-page-dropdown > ul');

	if (containerSecondaryMenu) {
		function getSecondaryMenuMaxFullHeight(el) {
			const clone = el.cloneNode(true);

			// Hide clone
			clone.style.position = 'absolute';
			clone.style.visibility = 'hidden';
			clone.style.pointerEvents = 'none';
			clone.style.top = '-9999px';
			clone.style.left = '-9999px';
			clone.style.width = '100%';

			document.body.appendChild(clone);

			const itemHeights = {};
			let maxHeight = 0;

			// clone.forEach((item, index) => {
			clone.style.display = 'block';
			clone.style.maxHeight = 'none';
			clone.style.overflow = 'visible';

			const height = clone.scrollHeight;

			// Store individual height
			itemHeights[0] = height;

			// Track max height
			maxHeight = Math.max(maxHeight, height);
			// });

			document.body.removeChild(clone);

			return {
				item: itemHeights,
				maxHeight,
			};
		}

		const containerSecondaryMenuHeight = getSecondaryMenuMaxFullHeight(containerSecondaryMenu);
		containerSecondaryMenu.setAttribute('data-max-height', containerSecondaryMenuHeight.maxHeight);

		document.querySelector('.dropdown-active-page a').addEventListener('click', function (e) {
			e.preventDefault();

			let screenWidthSize = document.querySelector('.chart-landing-page-menu') ? 1023 : 767;

			if (window.innerWidth <= screenWidthSize) {
				slideToggle(containerSecondaryMenu);

				this.parentElement.classList.toggle('child-dropdown-active');
			}
		});

		function slideToggle(el) {
			const isHidden = el.offsetHeight === 0;
			const maxHeight = Number(el.dataset.maxHeight) + 2;

			if (isHidden) {
				el.style.display = "block";

				el.animate(
					[
						{ height: "0px", padding: "0px" },
						{ height: maxHeight + "px", padding: "" }
					],
					{
						duration: 300,
						easing: "ease"
					}
				).onfinish = () => {
					el.style.height = maxHeight + "px";
				};

			} else {
				el.animate(
					[
						{ height: maxHeight + "px", padding: "" },
						{ height: "0px", padding: "0px" }
					],
					{
						duration: 300,
						easing: "ease"
					}
				).onfinish = () => {
					el.style.height = "0px";
					el.style.display = "none";
				};
			}
		}
	}

	// content promoting popup
	const contentPromotingPopup = document.querySelector('.content-promoting-popup');
	const contentPromotingCalendar = document.querySelector('.content-promoting-calendar');

	if (contentPromotingPopup) {
		const closePromotingPopupBtn = contentPromotingPopup.querySelector('.close-popup-btn');
		const viewPromotingPopupBtn = contentPromotingCalendar ? contentPromotingCalendar.querySelector('.view-popup-btn') : null;
		const promotingPopupStateKey = 'pioneerContentPromotingPopup';
		// Fallback for browsers/modes where `sessionStorage` is unavailable
		let promotingPopupState = null;

		// Remember the user's last choice for this tab session only
		function getPromotingPopupState() {
			if (promotingPopupState) {
				return promotingPopupState;
			}

			try {
				return window.sessionStorage.getItem(promotingPopupStateKey);
			} catch (e) {
				return null;
			}
		}

		function setPromotingPopupState(state) {
			promotingPopupState = state;

			try {
				window.sessionStorage.setItem(promotingPopupStateKey, state);
			} catch (e) {
				// Storage is full or blocked, the in-memory state still covers this page
			}
		}

		// Pressidium Cookie Consent keeps the user's choice in its own cookie and
		// exposes the vanilla-cookieconsent API on `window.pressidiumCookieConsent`
		function hasCookieConsent() {
			const cookieConsent = window.pressidiumCookieConsent;

			if (cookieConsent && typeof cookieConsent.validConsent === 'function') {
				return cookieConsent.validConsent();
			}

			// Pressidium's script may not have run yet, fall back to reading its cookie
			const cookieName = window.pressidiumCCCookieName || 'pressidium_cookie_consent';

			return document.cookie.split(';').some(function (cookie) {
				return cookie.trim().indexOf(cookieName + '=') === 0;
			});
		}

		function togglePromotingElement(element, isVisible) {
			if (!element) {
				return;
			}

			element.classList.toggle('active', isVisible);
			element.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
		}

		// The popup and the calendar toggle are never visible at the same time
		function openPromotingPopup() {
			togglePromotingElement(contentPromotingCalendar, false);
			togglePromotingElement(contentPromotingPopup, true);
		}

		function closePromotingPopup() {
			togglePromotingElement(contentPromotingPopup, false);
			togglePromotingElement(contentPromotingCalendar, true);
		}

		function revealPromotingContent() {
			const isPromotingContentVisible = contentPromotingPopup.classList.contains('active')
				|| (contentPromotingCalendar && contentPromotingCalendar.classList.contains('active'));

			if (isPromotingContentVisible) {
				return;
			}

			// Let the hidden state paint first so the slide-up animation always runs
			requestAnimationFrame(function () {
				requestAnimationFrame(function () {
					if (getPromotingPopupState() === 'closed') {
						// Popup was dismissed earlier this session, only bring back the calendar
						closePromotingPopup();
						return;
					}

					openPromotingPopup();
				});
			});
		}

		if (closePromotingPopupBtn) {
			closePromotingPopupBtn.addEventListener('click', function (e) {
				e.preventDefault();

				setPromotingPopupState('closed');
				closePromotingPopup();
			});
		}

		if (viewPromotingPopupBtn) {
			viewPromotingPopupBtn.addEventListener('click', function (e) {
				e.preventDefault();

				setPromotingPopupState('open');
				openPromotingPopup();
			});
		}

		// Consent already given on an earlier visit, no need to wait for a button click
		if (hasCookieConsent()) {
			revealPromotingContent();
		}

		// Accept All / Reject All / Save Preferences
		window.addEventListener('pressidium-cookie-consent-accepted', revealPromotingContent);
		window.addEventListener('pressidium-cookie-consent-changed', revealPromotingContent);

		// Pressidium is not on the page (plugin disabled or blocked), keep the popup usable
		window.addEventListener('load', function () {
			setTimeout(function () {
				if (!window.pressidiumCookieConsent && !document.getElementById('cc--main')) {
					revealPromotingContent();
				}
			}, 500);
		});
	}
});